import React, { useState } from 'react';
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Menu, MenuItem,
} from '@mui/material';
import MoreHorizRounded from '@mui/icons-material/MoreHorizRounded';
import { isFinishedPreparation } from './preparationArchiveModel';

const PreparationLifecycleMenu = ({ draft, canManage, onArchive, onRestore }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!canManage) return null;

  const archived = draft?.isArchived === true;
  const closeMenu = () => setAnchorEl(null);
  const runRestore = async () => {
    closeMenu();
    setBusy(true);
    try { await onRestore?.(); } finally { setBusy(false); }
  };
  const runArchive = async () => {
    setBusy(true);
    try {
      const succeeded = await onArchive?.();
      if (succeeded !== false) setConfirming(false);
    } finally { setBusy(false); }
  };

  return (
    <>
      <IconButton
        aria-label="Preparation actions"
        disabled={busy}
        onClick={(event) => { event.stopPropagation(); setAnchorEl(event.currentTarget); }}
        size="small"
      >
        <MoreHorizRounded />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu}>
        {archived ? (
          <MenuItem onClick={runRestore}>Restore preparation</MenuItem>
        ) : (
          <MenuItem onClick={() => { closeMenu(); setConfirming(true); }}>Archive preparation</MenuItem>
        )}
      </Menu>
      <Dialog open={confirming} onClose={() => !busy && setConfirming(false)}>
        <DialogTitle>Archive preparation?</DialogTitle>
        <DialogContent>
          {isFinishedPreparation(draft)
            ? 'It will move out of Your preparations, but its reports and history will remain available.'
            : 'This preparation is not finished. Archiving will preserve your progress, and you can restore it later.'}
        </DialogContent>
        <DialogActions>
          <Button disabled={busy} onClick={() => setConfirming(false)}>Cancel</Button>
          <Button disabled={busy} onClick={runArchive}>Archive</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PreparationLifecycleMenu;
